import store from "../store";

export const calcDays = async (date1, date2) => {
  if (!date1 || !date2 || date1 === "Invalid date" || date2 === "Invalid date")
    return "";

  return await store.dispatch("GET_DAYS", { from: date1, to: date2 });
};
